import { InjectionToken } from "@angular/core";

import type { IAuthProvider } from "./interfaces";

/**
 * Resolves to the active IdP implementation of IAuthProvider. For the internal
 * (AAD) build this is wired to SpAuthService in app.config.ts; the external
 * build swaps in the Auth0 implementation via the `authProvider` config flag.
 */
export const AUTH_PROVIDER = new InjectionToken<IAuthProvider>("AUTH_PROVIDER");
